module.exports = __webpack_public_path__ + "static/img/sample-pic1.13caa851.png";